import type { LevelWithSilent } from 'pino';

import pino from 'pino';

const VALID_LEVELS = new Set<LevelWithSilent>([
  'trace',
  'debug',
  'info',
  'warn',
  'error',
  'fatal',
  'silent',
]);

function resolveLevel(): LevelWithSilent {
  const raw = import.meta.env.VITE_LOG_LEVEL;
  if (typeof raw === 'string' && raw.trim()) {
    const v = raw.trim().toLowerCase() as LevelWithSilent;
    if (VALID_LEVELS.has(v)) {
      return v;
    }
  }

  return import.meta.env.DEV ? 'debug' : 'info';
}

function writeLogObject(obj: object): void {
  const rec = obj as Record<string, unknown>;
  const level = typeof rec.level === 'number' ? rec.level : 30;
  if (level >= 50) {
    console.error(obj);
  } else if (level === 40) {
    console.warn(obj);
  } else {
    console.log(obj);
  }
}

const logger = pino({
  level: resolveLevel(),
  base: { service: 'processing-webapp' },
  serializers: {
    err: pino.stdSerializers.err,
  },
  browser: {
    write: writeLogObject,
  },
});

export default logger;
